import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {CardStoreService} from '../../shared/card-store.service';
import {CardPattern} from '../../shared/card-pattern';
import {DeckType} from '../../shared/card-deck';
import {CustomObjectsService} from '../../shared/custom-objects.service';
import {NoteType, RelationNote} from '../../shared/custom-objects';
import {ColorFactory} from '../../shared/color-factory';
import {GameDesignService} from '../../design-recommender/shared/game-design.service';
import {MessageFactoryService} from '../../shared/message-factory.service';
import {ObjectExtractingServiceService} from '../../shared/object-extracting-service.service';

@Component({
  selector: 'em-note-dialog-relation',
  templateUrl: './note-dialog-relation.component.html',
  styleUrls: ['./note-dialog-relation.component.css']
})
export class NoteDialogRelationComponent implements OnInit, OnDestroy {

  get selectedColor(): string {
    return ColorFactory.getColor(this.note.type) || '#000000';
  }


  constructor(
    private dialogRef: MatDialogRef<NoteDialogRelationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      sourceCardPatternId: number,
      targetCardPatternId: number,
      sourceCardPatternName: string,
      targetCardPatternName: string,
      sourceCardDeckType: DeckType,
      targetCardDeckType: DeckType,
      designName: string,
      createdDateTime: string
    },
    private gs: GameDesignService,
    private mfs: MessageFactoryService,
    private oes: ObjectExtractingServiceService,
    private cos: CustomObjectsService,
    private cs: CardStoreService,
  ) {
    this.targetCardPatternId = data.targetCardPatternId;
    this.sourceCardPatternId = data.sourceCardPatternId;
    this.sourceCardPatternName = data.sourceCardPatternName;
    this.targetCardPatternName = data.targetCardPatternName;
    this.sourceCardDeckType = data.sourceCardDeckType;
    this.targetCardDeckType = data.targetCardDeckType;
    this.designName = data.designName;
    this.createdDateTime = data.createdDateTime;
    this.mfs.initialize(data.designName, data.createdDateTime);
  }

  @Input() sourceCardPatternId: number;
  @Input() targetCardPatternId: number;
  @Input() sourceCardPatternName: string;
  @Input() targetCardPatternName: string;
  @Input() sourceCardDeckType: DeckType;
  @Input() targetCardDeckType: DeckType;
  @Input() designName: string;
  @Input() createdDateTime: string;
  sourceCardPattern$: Observable<CardPattern>;
  targetCardPattern$: Observable<CardPattern>;

  protected readonly ColorFabric = ColorFactory;
  readonly NoteType = NoteType;
  readonly DeckType = DeckType;

  // Sticky Note Colors
  note: RelationNote;

  ngOnDestroy() {
    // CALL WEBSOCKET CONNECTION
    const linkObject = this.mfs.buildLinkObject(
      this.sourceCardPatternId,
      this.targetCardPatternId,
      this.sourceCardDeckType,
      this.targetCardDeckType,
      this.sourceCardPatternName,
      this.targetCardPatternName);
    const messageObject = this.mfs.createMessageLeaveLinkNote(linkObject);
    this.oes.handleAction(messageObject);
  }

  ngOnInit(): void {
    if (this.gs.hasGameDesignRelation(this.sourceCardPatternId, this.targetCardPatternId)
      || this.gs.hasGameDesignProblemRelation(this.sourceCardPatternId, this.targetCardPatternId)) {
      this.sourceCardPattern$ = this.cs.getPatternCardWithCell(234754, this.sourceCardPatternId, DeckType.pattern);
      this.targetCardPattern$ = this.cs.getPatternCardWithCell(234754, this.targetCardPatternId, DeckType.pattern);
      if (this.cos.hasRelationNote(this.sourceCardPatternId, this.targetCardPatternId)) {
        const noteTemp = this.cos.getRelationNote(this.sourceCardPatternId, this.targetCardPatternId);
        this.note = {
          sourceId: noteTemp.sourceId,
          targetId: noteTemp.targetId,
          text: noteTemp.text,
          type: noteTemp.type
        };
      } else {
        this.note = {
          sourceId: this.sourceCardPatternId,
          targetId: this.targetCardPatternId,
          text: '',
          type: NoteType.RELATION_ELEMENT
        };
      }
    } else {
      throw new Error('Trying to add relationNote to non existing relation');
    }
  }

  saveNote(): void {
    this.cos.addOrUpdateRelationNote(
      this.note.text.trim(),
      this.sourceCardPatternId,
      this.targetCardPatternId,
      this.sourceCardPatternName,
      this.targetCardPatternName,
      this.sourceCardDeckType,
      this.targetCardDeckType);
    this.dialogRef.close();
  }

  getColor(type: NoteType) {
    return ColorFactory.getColor(type);
  }

  getCardNoteText(cardPattern: CardPattern) {
    if (this.hasCardNote(cardPattern)) {
      const cardNote = this.cos.getCardNote(cardPattern.id);
      return cardNote.text.trim();
    }else {
      return cardPattern.summary.trim();
    }
  }

  hasCardNote(cardPattern: CardPattern) {
    return this.cos.hasCardNote(cardPattern.id);
  }

  getCardNoteType(cardPattern: CardPattern) {
    if (this.hasCardNote(cardPattern)){
      const cardNote = this.cos.getCardNote(cardPattern.id);
      return cardNote.type;
    }else{
      return NoteType.MISSING_NOTE;
    }
  }

  hasRelationNote() {
    return this.cos.hasRelationNote(this.sourceCardPatternId, this.targetCardPatternId);
  }

  removeRelationNote() {
    this.cos.removeRelationNote(
      this.sourceCardPatternId,
      this.targetCardPatternId,
      this.sourceCardDeckType,
      this.targetCardDeckType,
      this.sourceCardPatternName,
      this.targetCardPatternName);
  }

  toggleChange(event: any) {
    const toggle = event.source;
    if (toggle && event.value.some((item: any) => item === toggle.value)) {
      toggle.buttonToggleGroup.value = [toggle.value];
    }
  }
}
